export const isTouch = typeof window !== 'undefined' && 'ontouchstart' in window;
